import { useTRPC } from "@/trpc/client";
import { useMutation, useQueryClient } from "@tanstack/react-query";

function invalidateOnboarding(qc: ReturnType<typeof useQueryClient>) {
  qc.invalidateQueries({ queryKey: [["onboarding"]] });
}

export function useSaveOnboardingDraft() {
  const trpc = useTRPC();
  const qc = useQueryClient();
  return useMutation({
    ...trpc.onboarding.saveDraft.mutationOptions(),
    onSuccess: () => invalidateOnboarding(qc),
  });
}

export function useSaveOrganisation() {
  const trpc = useTRPC();
  const qc = useQueryClient();
  return useMutation({
    ...trpc.onboarding.saveOrganisation.mutationOptions(),
    onSuccess: () => invalidateOnboarding(qc),
  });
}

export function useMarkOnboardingComplete() {
  const trpc = useTRPC();
  const qc = useQueryClient();
  return useMutation({
    ...trpc.onboarding.markComplete.mutationOptions(),
    onSuccess: () => invalidateOnboarding(qc),
  });
}

export function useAttest() {
  const trpc = useTRPC();
  const qc = useQueryClient();
  return useMutation({
    ...trpc.onboarding.attest.mutationOptions(),
    onSuccess: () => invalidateOnboarding(qc),
  });
}

export function useSuggestInviteGreeting() {
  const trpc = useTRPC();
  return useMutation({ ...trpc.onboarding.suggestInviteGreeting.mutationOptions() });
}
